import React, { useEffect, useRef, useState } from "react";
import styles from "./dropdown.module.css";
import { DropdownOptions, GenerativeSearchReq, QueryType } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { fetchGenAIQueryResponse, setAnswerSpinner } from "../../store/reducers/app";
import { domain } from "../../store/constants";
import { v4 as uuidv4 } from "uuid";
import { AppDispatch, RootState } from "../../store/store";

const Icon = () => {
  return (
    <svg height="20" width="20" viewBox="0 0 20 20">
      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
    </svg>
  );
};
const Dropdown = ({
  placeHolder,
  ques,
  setQues,
  questionClicked,
  options,
  onEnterClick,
  err,
  showErr,
}: {
  placeHolder: string;
  ques: string;
  setQues: (que: string) => void;
  questionClicked: string;
  options: DropdownOptions[];
  onEnterClick: () => void;
  err: boolean;
  showErr: (value: boolean) => void;
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [selectedValue, setSelectedValue] = useState<DropdownOptions | null>(null);
  const searchRef: any = useRef();
  const inputRef: any = useRef();
  const dispatch = useDispatch<AppDispatch>();
  const userState = useSelector((state: RootState) => state.userDetails);
  const sessionId = useSelector((state: RootState) => state.sessionId);
  const headersAre = useSelector((state: RootState) => state.headers);

  useEffect(() => {
    const val = {
      label: questionClicked,
      value: questionClicked,
      submitted: true,
    };
    setSelectedValue(val);
  }, [questionClicked]);

  useEffect(() => {
    if (!showMenu && ques !== "") {
      const newValue = { label: ques, value: ques };
      setSelectedValue(newValue);
      setQues(ques);
    }
    if (showMenu && searchRef.current) {
      searchRef.current.focus();
    }
  }, [showMenu]);
  useEffect(() => {
    const handler = (e: any) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("click", handler);
    };
  });
  const handleKeyDown = (event: any) => {
    showErr(false);
    if (event.key === "Enter") {
      const newValue = { label: event.target.value, value: event.target.value };
      setSelectedValue(newValue);
      setQues(event.target.value);
      setShowMenu(false);
      onEnterClick();
      event.target.blur();
    }
  };

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQues(e.target.value);
  };
  const getOptions = () => {
    if (!ques) {
      return options;
    }
    //search value options filter
    return options.filter(
      (option) => option.label.toLowerCase().indexOf(ques.toLowerCase()) >= 0
    );
  };
  const handleMenuOpening = () => {
    setShowMenu(!showMenu);
  };

  const onItemClick = (option: DropdownOptions) => {
    let newValue = option;
    showErr(false);
    setSelectedValue(newValue);
    setQues(option.label);
    dispatch(setAnswerSpinner({ loading: true, searchQuestion: option.label }));
    const payload: GenerativeSearchReq = {
      query: option.label,
      metadata: {
        domain: domain,
        query_id: uuidv4(),
        session_id: sessionId,
        user_id: userState.userId,
        business_unit: userState.businessUnit,
      },
    };
    const logAnswerPayload = {
      sessionId: sessionId,
      queryId: payload.metadata.query_id,
      userId: userState.userId,
      state: userState.state,
      queryType: QueryType.FREQUENTLY_USED,
      query: option.label,
      response: "",
      businessUnit: userState.businessUnit,
      createdTimestamp: new Date().toISOString(),
    };
    const reqData = { payload, logAnswerPayload,headers: headersAre };
    dispatch(fetchGenAIQueryResponse(reqData));
  };

  const isSelected = (option: DropdownOptions) => {
    if (!selectedValue) {
      return false;
    }
    return selectedValue.value === option.value;
  };
  const handleTextFocus = (e: React.FocusEvent<HTMLInputElement>) => e.target.select();
  return (
    <div className={`${err ? styles.errorBorder : ""} ${styles.dropdownContainer}`}>
      <div ref={inputRef} className={styles.dropdownInput} onClick={handleMenuOpening}>
        <div className={styles.dropdownSelectedValue}>
          <input
            className={styles.dropdownInput}
            onChange={onSearch}
            onKeyDown={handleKeyDown}
            onFocus={handleTextFocus}
            placeholder={placeHolder}
            value={ques}
            ref={searchRef}
          />
        </div>
        {showMenu && (
          <div className={styles.dropdownMenu}>
            {getOptions().map((option, key) => (
              <div
                key={`${key}-${option.value}`}
                onClick={() => onItemClick(option)}
                className={`${styles.dropdownItem} ${isSelected(option) && styles.selected}`}
              >
                {" "}
                {option.label}
              </div>
            ))}
          </div>
        )}
        <div className={styles.dropdownTools}>
          <div>
            <Icon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
